import {InputTextarea, type InputTextareaProps} from "primereact/inputtextarea";
import type {ComponentProps, Ref} from "react";

/**
 * PrimeReact's `IconField` clones `iconPosition` onto every child. `InputIcon` and `InputText` consume it, but a
 * plain `<label>` (the float label) and `InputTextarea` hand it on to the DOM, which React reports as an unknown
 * attribute. Use these drop-in replacements as direct children of an `IconField`.
 */
type WithIconPosition<P> = P & {iconPosition?: string};

export function IconFieldLabel({iconPosition: _iconPosition, ...props}: WithIconPosition<ComponentProps<"label">>) {
    return <label {...props} />;
}

export function IconFieldTextarea({
    iconPosition: _iconPosition,
    ...props
}: WithIconPosition<InputTextareaProps & {ref?: Ref<HTMLTextAreaElement>}>) {
    return <InputTextarea {...props} />;
}
